import IconLightbulb from "assets/svgs/Lightbulb.svg";
export default function BottomInfo() {
  return (
    <div className="mt-auto p-5 mx-3 mb-7 bg-gray-150 rounded-sm">
      <h3 className="text-lg font-bold mb-2 flex items-center">
        <IconLightbulb width="20" className="-ml-2" />
        <span className="ml-3">How does the review process work?</span>
      </h3>
      <ol className="pl-4" style={{ listStyle: "normal" }}>
        <li>
          A source of information is submitted for a case. The more information
          included, the more quickly it will be reviewed.
        </li>
        <li>
          The source and accompanying information is reviewed for accuracy and
          relevancy. It can be approved, or declined.
        </li>
        <li>
          The Uncovered Case Research team reviews the source where it is either
          published on the case, or it will undergo additional work.
        </li>
      </ol>
    </div>
  );
}
